import { Component, ViewChild, Output, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IAbstractView } from '@core/interfaces';
import { ILocationMapComponent, ILocationMapPresenter } from './interfaces';
import { LocationMapPresenter } from './location-map.presenter';
import { ClientLocation, Store } from '@core/models';

@Component({
	selector: 'app-location-map',
	templateUrl: './location-map.component.html',
	styleUrls: ['./location-map.component.scss'],
	imports: [CommonModule],
	providers: [LocationMapPresenter],
	standalone: true,
})
export class LocationMapComponent extends IAbstractView<ILocationMapPresenter> implements ILocationMapComponent {
	map = this.presenter.map;
	markers = this.presenter.markers;
	circles = this.presenter.circles;
	userMarker = this.presenter.userMarker;
	darkMode = this.presenter.darkMode;
	darkModeMediaQuery = this.presenter.darkModeMediaQuery;

	@Input() storeMarkerColor = this.presenter.storeMarkerColor;
	@Input() userMarkerColor = this.presenter.userMarkerColor;

	@Input()
	set isDarkMode(val: boolean | undefined) {
		if (typeof val === 'boolean') {
			this.presenter.setDarkMode(val);
		}
	}

	@ViewChild('mapContainer', { static: true }) mapContainer = this.presenter.mapContainer;
	@Output() addressSelected = this.presenter.addressSelected;

	constructor(presenter: LocationMapPresenter) {
		super(presenter);
	}

	setupDarkModeListener(): void {
		this.presenter.setupDarkModeListener();
	}

	applyMapStyle(): void {
		this.presenter.applyMapStyle();
	}

	setDarkMode(isDark: boolean): void {
		this.presenter.setDarkMode(isDark);
	}

	initMap(storeList: Store[], clientLocation: ClientLocation | null): void {
		this.presenter.initMap(storeList, clientLocation);
	}

	updateUserMarker(clientLocation: ClientLocation | null): void {
		this.presenter.updateUserMarker(clientLocation);
	}
}
